/**
 * Playtester Tier System
 * 5 tiers: 5-200 playtesters
 */

export const PLAYTESTER_TIERS = [
  {
    id: 1,
    name: "Starter",
    minPlaytesters: 5,
    maxPlaytesters: 20,
    defaultPlaytesters: 10,
    description: "Perfect for small-scale testing",
    price: 0,
  },
  {
    id: 2,
    name: "Standard",
    minPlaytesters: 21,
    maxPlaytesters: 50,
    defaultPlaytesters: 35,
    description: "Ideal for medium-sized games",
    price: 0,
  },
  {
    id: 3,
    name: "Professional",
    minPlaytesters: 51,
    maxPlaytesters: 100,
    defaultPlaytesters: 75,
    description: "Comprehensive testing coverage",
    price: 0,
  },
  {
    id: 4,
    name: "Enterprise",
    minPlaytesters: 101,
    maxPlaytesters: 150,
    defaultPlaytesters: 125,
    description: "Large-scale testing campaigns",
    price: 0,
  },
  {
    id: 5,
    name: "Premium",
    minPlaytesters: 151,
    maxPlaytesters: 200,
    defaultPlaytesters: 175,
    description: "Maximum testing capacity",
    price: 0,
  },
];

/**
 * Get tier by number of playtesters
 */
export function getTierByPlaytesterCount(count) {
  return PLAYTESTER_TIERS.find(
    tier => count >= tier.minPlaytesters && count <= tier.maxPlaytesters
  ) || PLAYTESTER_TIERS[0];
}

/**
 * Get tier by ID
 */
export function getTierById(tierId) {
  return PLAYTESTER_TIERS.find(tier => tier.id === tierId) || PLAYTESTER_TIERS[0];
}

/**
 * Validate playtester count for a tier
 */
export function validatePlaytesterCount(tierId, count) {
  const tier = getTierById(tierId);
  return count >= tier.minPlaytesters && count <= tier.maxPlaytesters;
}

















